import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionTitle, CTAButton } from './Shared';
import { volumes, bonuses, valueSummary, PRICE } from '../data/pack';
const VolumeBlock = () => <div className="mx-auto mb-20 max-w-5xl space-y-6 md:space-y-8" data-id="element-123" data-mp="3hb2kfpsaofoj">
    {volumes.map(vol => <article key={vol.n} className="paper-panel grid grid-cols-[104px_1fr] gap-5 rounded-2xl p-5 text-left md:grid-cols-[220px_1fr] md:gap-10 md:p-8" data-id="element-124" data-mp="3m945gg9a6p2n">
        <img src={vol.cover} alt={`${vol.label} — ${vol.title}`} loading="lazy" className="w-full self-start rounded-sm ring-1 ring-brand-goldDark/25" data-id="element-125" data-mp="isxbx2kky87l" />
        <div className="flex flex-col justify-center" data-id="element-126" data-mp="9341i4w6bz4x">
          <span className={`font-display text-[10px] font-semibold uppercase tracking-[0.24em] ${vol.accent}`} data-id="element-127" data-mp="91j66d21cc60">
            {vol.label}
          </span>
          <h3 className={`mt-1.5 font-serif text-xl font-semibold leading-tight md:text-3xl ${vol.accent}`} data-id="element-128" data-mp="11kgfbaiinoa5">
            {vol.title}
          </h3>
          <p className="mt-1.5 font-display text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-goldDark md:text-[11px]" data-id="element-129" data-mp="3k8jp62wd7abv">
            {vol.subtitle}
          </p>
          <p className="mt-3 font-serif text-[15px] italic leading-snug text-brand-textLight/85 md:text-lg" data-id="element-130" data-mp="2twd810fveiu">
            {vol.intro}
          </p>

          <p className="mt-5 font-display text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-muted" data-id="element-131" data-mp="brou39lt6u8c">
            Inside this volume
          </p>
          <ul className="mt-2.5 grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2" data-id="element-132" data-mp="6vrjljx88i3h">
            {vol.features.map(f => <li key={f} className="flex items-start gap-2 text-brand-text" data-id="element-133" data-mp="gr1k237z8hf5">
                <span aria-hidden="true" className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-brand-gold" data-id="element-134" data-mp="2ni0zuv2avtgu" />
                <span className="text-[13px] leading-snug md:text-[15px]" data-id="element-135" data-mp="2ikipd08mx66q">
                  {f}
                </span>
              </li>)}
          </ul>

          <p className="mt-5 border-t border-brand-goldDark/15 pt-4 font-serif text-[15px] italic text-brand-burgundy md:text-lg" data-id="element-136" data-mp="3c7wx2y660cdy">
            {vol.closing}
          </p>
        </div>
      </article>)}
  </div>;
const BonusBlock = () => <div className="mx-auto max-w-5xl" data-id="element-137" data-mp="3m85z4smu8s19">
    <div className="mb-3 text-center" data-id="element-138" data-mp="3r67dj09bk36e">
      <h3 className="font-display text-base font-semibold uppercase tracking-[0.14em] text-brand-burgundy md:text-xl" data-id="element-139" data-mp="3r564f1bv5qrb">
        5 Practical Bonuses —{' '}
        <span className="text-brand-goldDark" data-id="element-140" data-mp="3t54hody7hw1">Always Included</span>
      </h3>
      <p className="mx-auto mt-3 max-w-2xl font-serif text-base italic text-brand-textLight/85 md:text-lg" data-id="element-141" data-mp="3v7qzyfw6sw0">
        Additional tools designed to make your classes easier to organize,
        personalize and manage.
      </p>
    </div>

    <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-142" data-mp="ipmeocaeiqh0">
      {bonuses.map(bonus => <article key={bonus.n} className="paper-panel flex h-full flex-col rounded-xl p-5 text-left" data-id="element-143" data-mp="2397yvwxyja64">
          <span className="font-display text-[10px] font-semibold uppercase tracking-[0.24em] text-brand-goldDark" data-id="element-144" data-mp="1y7sf087in9pb">
            {bonus.n}
          </span>
          <h4 className="mt-1.5 font-serif text-lg font-semibold leading-tight text-brand-burgundy md:text-xl" data-id="element-145" data-mp="1obpef6sbbj4h">
            {bonus.title}
          </h4>
          <p className="mt-2 text-[13px] leading-snug text-brand-text md:text-sm" data-id="element-146" data-mp="2m0qzjx4iec4z">
            {bonus.intro}
          </p>
          <ul className="mt-4 space-y-1.5 border-t border-brand-goldDark/15 pt-4" data-id="element-147" data-mp="2c8lbgyhdoev2">
            {bonus.includes.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-brand-text" data-id="element-148" data-mp="278qkyw1ilraj">
                <span aria-hidden="true" className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-brand-gold" data-id="element-149" data-mp="34r0gkd4yg8gq" />
                {item}
              </li>)}
          </ul>
          <p className="mt-auto pt-4 font-display text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-goldDark" data-id="element-150" data-mp="2pg23nq0dunm7">
            Free with your bundle
          </p>
        </article>)}
    </div>
  </div>;
const ValueSummary = () => <div className="mx-auto mt-20 max-w-3xl" data-id="element-151" data-mp="2fhl96j28jqve">
    <div className="paper-panel rounded-3xl p-6 text-center md:p-10" data-id="element-152" data-mp="33773as3r3fwj">
      <h3 className="font-display text-lg font-bold uppercase tracking-[0.14em] text-brand-burgundy md:text-2xl" data-id="element-153" data-mp="3399u3ecq9d2b">
        Everything You Receive Today
      </h3>
      <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-2.5 text-left sm:grid-cols-2" data-id="element-154" data-mp="2tgci7r28qmco">
        {valueSummary.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-155" data-mp="2ye4aim6ssahe">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-156" data-mp="3m4qfg4li9en6" />
            <span className="text-sm text-brand-text md:text-[15px]" data-id="element-157" data-mp="3qwrqjn6xszbm">
              {item}
            </span>
          </li>)}
      </ul>

      <p className="mt-8 font-serif text-2xl font-semibold text-brand-burgundy md:text-3xl" data-id="element-158" data-mp="1ffokjr1ez7d6">
        Complete Bundle: Only {PRICE}
      </p>

      <div className="mt-6" data-id="element-159" data-mp="1p72lm390kf8f">
        <CTAButton className="w-full px-6 py-4 text-[12px] sm:w-auto md:px-10 md:text-sm" data-id="element-160" data-mp="1p61014udgacg">
          Yes, I Want the Complete Bundle
        </CTAButton>
      </div>

      <p className="mt-4 text-xs text-brand-muted md:text-sm" data-id="element-161" data-mp="wiev9t9eqzo0">
        One secure payment · No subscription · Instant access
      </p>
    </div>
  </div>;
export const PackContents = () => {
  return <Section id="whats-inside" data-id="element-162" data-mp="15juwpbi8vrg3">
      <SectionTitle eyebrow="What’s Inside" lead="A structured, highly visual collection created to help you prepare, organize and confidently lead Qigong sessions." data-id="element-163" data-mp="15k4moz3ahyls">
        Your Complete Professional Qigong Library
        <span className="mt-3 block font-display text-sm font-semibold uppercase tracking-[0.16em] text-brand-goldDark md:text-base" data-id="element-164" data-mp="2h0cvhi9be65w">
          3 Professional Volumes + 5 Free Bonuses
        </span>
      </SectionTitle>

      <VolumeBlock data-id="element-165" data-mp="1eku57ldnxmfz" />
      <BonusBlock data-id="element-166" data-mp="1ekauopqce0bz" />
      <ValueSummary data-id="element-167" data-mp="1ejj0njce8ant" />
    </Section>;
};